<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm">
            <el-form-item label="供应商/通道名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAccountHandle" icon="el-icon-search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="showAddAccount" icon="el-icon-edit">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border highlight-current-row>
            <el-table-column prop="name" label="供应商名称" width="100px"></el-table-column>
            <el-table-column prop="alias" label="通道" width="80px"></el-table-column>
            <el-table-column prop="accountName" label="主账号"></el-table-column>
            <el-table-column prop="pwd" label="主密码"></el-table-column>
            <el-table-column prop="newAccountName" label="次账号"></el-table-column>
            <el-table-column prop="newPwd" label="次密码"></el-table-column>
            <el-table-column prop="pwdKey" label="密钥"></el-table-column>
            <el-table-column prop="isAuthName" label="绑定手机号"></el-table-column>
            <el-table-column prop="typeName" label="所属类别" width="100px"></el-table-column>
            <el-table-column label="状态" width="100px">
                <template slot-scope="scope">
                    <span v-if="scope.row.state == 0" style="color: red">{{ scope.row.stateName }}</span>
                    <span v-if="scope.row.state == 1" style="color: green">{{ scope.row.stateName }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="questUrl" label="供应商链接"></el-table-column> -->
            <el-table-column label="操作" width="180px" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showEditAccount(scope.row.id)"
                        icon="el-icon-edit">编辑</el-button>
                    <el-button type="text" style="color: red" size="small" @click="deleteData(scope.row.id)">删除</el-button>
                    <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">{{
                        showbtnText(scope.row.state) }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" :title="title" :visible.sync="accountVisibale" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="addOrEditAccountForm" :model="addOrEditAccountForm" :rules="addOrEditAccountRules"
                label-width="120px">
                <el-form-item label="通道名称：" prop="name">
                    <el-input v-model.trim="addOrEditAccountForm.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="通道：" prop="alias">
                    <el-input v-model.trim="addOrEditAccountForm.alias" clearable></el-input>
                </el-form-item>
                <el-form-item label="主账号：" prop="accountName">
                    <el-input v-model.trim="addOrEditAccountForm.accountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="主密码：" prop="pwd">
                    <el-input v-model.trim="addOrEditAccountForm.pwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="次账号：" prop="newAccountName">
                    <el-input v-model.trim="addOrEditAccountForm.newAccountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="次密码：" prop="newPwd">
                    <el-input v-model.trim="addOrEditAccountForm.newPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="密钥：" prop="pwdKey">
                    <el-input v-model.trim="addOrEditAccountForm.pwdKey" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="供应商链接：" prop="questUrl">
                    <el-input v-model.trim="addOrEditAccountForm.questUrl" clearable></el-input>
                </el-form-item>
                <el-form-item label="绑定手机号：">
                    <el-select v-model="addOrEditAccountForm.isAuth" placeholder="请选择">
                        <el-option v-for="item in supplierOption1" :value="item.code" :key="item.description"
                            :label="item.description"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="对接类型：">
                    <el-select v-model="addOrEditAccountForm.type" placeholder="请选择">
                        <el-option v-for="item in supplierOption" :value="item.code" :key="item.description"
                            :label="item.description"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtAccountHandle">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getSupplierListPage, addAccount, editAccount, getAccountInfo, changeAccountState, changeSimIntoHistory } from '@/api/system.js'
import { mapGetters } from "vuex";
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                name: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
            addFlag: false,
            accountVisibale: false,
            currentId: '',
            addOrEditAccountForm: {
                name: '',
                alias: '',
                accountName: '',
                pwd: '',
                newAccountName: '',
                newPwd: '',
                pwdKey: '',
                flowRatePool: '111',
                questUrl: '',
                type: '',
                isAuth: ''
            },
            title: '',
            supplierOption1: [
                {
                    code: 1,
                    description: '无需绑定'
                },
                {
                    code: 2,
                    description: '绑定手机号'
                }
            ],
            supplierOption: [],
            addOrEditAccountRules: {
                name: [
                    { required: true, message: '请输入供应商名称', trigger: 'blur' }
                ],
                alias: [
                    { required: true, message: '请输入通道', trigger: 'blur' }
                ],
                accountName: [
                    { required: true, message: '请输入账户', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                pwdKey: [
                    { required: true, message: '请输入密钥', trigger: 'blur' }
                ],
                flowRatePool: [
                    { required: true, message: '请输入流量池', trigger: 'blur' }
                ],
                questUrl: [
                    { required: false, message: '请输入供应商网站链接', trigger: 'blur' }
                ]
            }
        }
    }, computed: {
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority"
        })
    },
    methods: {
        deleteData(id) {
            let self = this;
            self.$confirm("您确定删除通道下的SIM卡嘛？此操作不可恢复", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.sysRequest('sim/supplier/deleteSim', { id: id }, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getAccountHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            });
        },
        changeSimIntoHistoryHandler(id) {
            let self = this;
            self.$confirm("您确定将此通道下的SIM卡,导入历史库吗", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                changeSimIntoHistory(id).then(res => {
                    let result = res.data;
                    if (result.code == 200) {
                        self.$message.success('卡片已导入历史表,需要查询历史,请移步历史卡片管理.');
                    } else {
                        self.$message.error(res.data.message);
                    }
                });
            });
        },
        cancel() {
            this.accountVisibale = false;
            this.$refs.addOrEditAccountForm.resetFields();
        },
        showbtnText(state) {
            return common.showTxtByState(state, { 0: '启用', 1: '禁用' })
        },
        getAccountHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getSupplierListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddAccount() {
            this.title = '新增账户';
            this.addFlag = true;
            this.accountVisibale = true;
        },
        showEditAccount(id) {
            this.title = '修改账户';
            this.addFlag = false;
            this.accountVisibale = true;
            this.currentId = id;
            var data = {
                id
            }
            getAccountInfo(data).then(res => {
                var result = res.data;
                if (result.code == 200) {
                    this.addOrEditAccountForm.name = result.data.name;
                    for (var key in this.addOrEditAccountForm) {
                        this.addOrEditAccountForm[key] = result.data[key];
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        addOrEidtAccountHandle() {
            this.$refs.addOrEditAccountForm.validate(valid => {
                if (valid) {
                    var data = this.addOrEditAccountForm;
                    if (this.addFlag == true) {
                        addAccount(data).then(res => callback(res))
                    } else {
                        data.id = this.currentId
                        editAccount(data).then(res => callback(res))
                    }
                }
                var _this = this;
                function callback(res) {
                    if (res.data.code == 200) {
                        _this.getAccountHandle();
                        _this.accountVisibale = false;

                    } else {
                        _this.$message.error(res.data.message)
                    }
                }
            })
        },
        changeStateHandle(id) {
            var data = {
                id
            }
            changeAccountState(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    this.getAccountHandle();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getAccountHandle();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val
            this.getAccountHandle();
        }
    },
    created() {
        this.getAccountHandle();
        common.getSupplierOptionCom(this, 'supplierOption');
    }
}
</script>
<style lang="less" scoped></style>

